<div class="container-fluid">
  <div class="header-container">
    <div class="page-header flex">
        <a [routerLink]="['/store/dashboard']">
          <span pTooltip="Back to Dashboard" tooltipPosition="left" class="fa fa-chevron-left font-button"></span>
        </a>{{title}}</div>
    <div class="loading" *ngIf="loading">
      <div class="loader"></div>
    </div>
  </div>
  <div style="margin-top:4px;">
    <small>{{description}}</small>
  </div>
  <div class="content">    
    <p-table #dataTable [columns]="columns" [value]="data" [paginator]="true" [rows]="15">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.type !== 'action' ? col.field : ''">
            {{col.header}}
            <p-sortIcon [field]="col.field" style="vertical-align: middle;"></p-sortIcon>
          </th>
          <th style="width: 60px;"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-record let-columns="columns">
        <tr [pSelectableRow]="record">
          <td *ngFor="let col of columns">
            <div *ngIf="col.type!=='cyclist'">
              {{
                col.type==='distance' ? ((distanceMetric === 'km' ? record[col.field] : (record[col.field] / 1.609) | number : '.1-1') + ' '+distanceMetric) : 
                col.type==='hrs' ? ((record[col.field] | number : '.1-1') + ' Hrs') : 
                col.type==='date' ? (record[col.field] | date : 'yyyy-MM-dd') :
                  record[col.field]
              }}
            </div>
          </td>
          <td style="text-align:left;">
              <div pTooltip="{{ 'bikeshop.due_for_service_detail.view_cyclist' | translate }}" tooltipPosition="left" *ngIf="record.UserID" class="fa fa-cube font-button service-due" style="font-size: 24px;"
                (click)="openCyclist(record)"></div>            
            </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>